<template>
  <div class="content">
    <div class="top">
      <div class="el-steps-box">
        <el-steps :active="0" finish-status="success" simple>
          <el-step :title=ApplicationSelection></el-step>
          <el-step :title=AppLoadconditions></el-step>
          <el-step :title=ReducerLoadconditions></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="app_box">
      <el-row :gutter="30" style="width:90%;margin-left:70px;">
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(1)">
            <img src="../../assets/appPage_1.png" alt="">
            <h2>{{$t('message.RotaryTable')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(2)">
            <img src="../../assets/appPage_2.png" alt="">
            <h2>{{$t('message.ConveyorBelt')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(3)">
            <img src="../../assets/appPage_3.png" alt="">
            <h2>{{$t('message.PinionandRack')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(4)">
            <img src="../../assets/appPage_4.png" alt="">
            <h2>{{$t('message.LiftingandLoweringDevice')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(5)">
            <img src="../../assets/appPage_5.png" alt="">
            <h2>{{$t('message.AGVcar')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(6)">
            <img src="../../assets/appPage_6.png" alt="">
            <h2>{{$t('message.SrewDrive')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(7)">
            <img src="../../assets/appPage_7.png" alt="">
            <h2>{{$t('message.GearDrive')}}</h2>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" @click="switchSubcomponents(8)">
            <img src="../../assets/appPage_8.png" alt="">
            <h2>{{$t('message.SynchronousBeltDrive')}}</h2>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SelectedApp',
    data() {
      return {
        ApplicationSelection:this.$t('message.ApplicationSelection'),
        AppLoadconditions:this.$t('message.AppLoadconditions'),
        ReducerLoadconditions:this.$t('message.ReducerLoadconditions'),
        reducerSize:this.$t('message.reducerSize'),
        selectMotor:this.$t('message.selectMotor'),
        complete:this.$t('message.complete'),
        RotaryTable:this.$t('message.RotaryTable'),
        ConveyorBelt:this.$t('message.ConveyorBelt'),
        PinionandRack:this.$t('message.PinionandRack'),
        LiftingandLoweringDevice:this.$t('message.LiftingandLoweringDevice'),
        AGVcar:this.$t('message.AGVcar'),
        SrewDrive:this.$t('message.SrewDrive'),
        GearDrive:this.$t('message.GearDrive'),
        SynchronousBeltDrive:this.$t('message.SynchronousBeltDrive'),
      };
    },
    methods: {
      switchSubcomponents:function(data){
        if(data === 1){
          this.$emit("listenPageChange","to_TurnTablePage")
        }else if(data === 2){
          this.$emit("listenPageChange","to_ConveyorBeltPage")
        }else if(data === 3){
          this.$emit("listenPageChange","to_RackPage")
        }else if(data === 4){
          this.$emit("listenPageChange","to_LifterPage")
        }else if(data === 5){
          this.$emit("listenPageChange","to_AGVPage")
        }else if(data === 6){
          this.$emit("listenPageChange","to_ScrewPage")
        }else if(data === 7){
          this.$emit("listenPageChange","to_GearRotationPage")
        }else if(data === 8){
          this.$emit("listenPageChange","to_TimingBeltPage")
        }
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
    padding-bottom:20px;
  }
  .top {
    height:120px;
    border-bottom:1px solid #EBEBEB;
  }
  .el-steps-box {
    width:95%;
    margin:0 auto;
    padding-top:35px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:22% 100%;
    background-position-x:0%;
  }
  .app_box .grid-content {
    height:300px;
    background:#F1F1F1;
    border-radius: 15px;
    margin-top:30px;
  }
  .app_box .grid-content:hover {
    transform: scale(1.05);
    background: #142479;
    cursor: pointer;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    color:#F1F1F1;
  }
  .app_box .grid-content img{
    width:50%;
    height:50%;
    display:block;
    margin:0 auto;
    padding-top:40px;
  }
  .app_box .grid-content h2{
    text-align: center;
    padding-top:20px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .app_box .grid-content {
      height:225px;
      background:#F1F1F1;
      border-radius: 15px;
      margin-top:30px;
    }
    .app_box .grid-content img{
      width:52%;
      height:46%;
      display:block;
      margin:0 auto;
      padding-top:30px;
    }
    .app_box .grid-content h2{
      text-align: center;
      padding-top:20px;
    }
    @media screen and (min--moz-device-pixel-ratio:0) {
      .app_box .grid-content img{
        width:53%;
        height:46%;
        display:block;
        margin:0 auto;
        padding-top:40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ApplicationSelection/SelectedApp.vue